import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setQuestions = questions => {
	return {
		type: ActionTypes.LOAD_QUESTIONS,
		questions: questions.data
	};
};



export const setLevels = levels => {
	return {
		type: ActionTypes.LOAD_LEVELS,
		levels: levels.data
	};
};


export const setLevelCategories = levelCategories => {
	return {
		type: ActionTypes.LOAD_LEVELCATEGORIES,
		levelCategories: levelCategories.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadQuestions = () => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/sanofiapi/questions/list")
			.then(response => {
				dispatch(setQuestions(response.data));
			})
			.catch(error => {});
	};
};

export const loadLevels = (idcategory) => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/sanofiapi/questions/levels/"+idcategory)
			.then(response => {
				dispatch(setLevels(response.data));
			})
			.catch(error => {});
	};
};


export const loadLevelCategories = (idlevel) => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/sanofiapi/questions/levelcategories/"+idlevel)
			.then(response => {
				dispatch(setLevelCategories(response.data));
			})
			.catch(error => {});
	};
};


export const saveQuestion = (question/*, token*/) => {
	return dispatch => {
		//const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/questions/",
                question
                /*,
				{
					headers: { Authorization: AuthStr }
				}*/
			)
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};
